import { propertyNoGraphQLApi } from '../index'
import {
  guestFeedbackFormSubmission
} from '../../graphql_queries/form_management/guestFeedbackForm'

class GuestFeedBackApi {

  static submitForm (param) {
    // return propertyApi.post('', {
    //   query: guestFeedbackFormSubmission(param)
    // })
    return propertyNoGraphQLApi.put('api/v1/forms/guest-feedback/create', param)
  }

  static getGuestFeedbackDetails(token) {
    return propertyNoGraphQLApi.get(`api/v1/forms/guest-feedback-form/${token}`)
  }

}

export default GuestFeedBackApi
